// Module
var code = "<div class=\"content-container\" ng-transclude> </div> ";
// Exports
module.exports = code;